import { render, staticRenderFns } from "./PublicTable.vue?vue&type=template&id=3c94892c&scoped=true&"
import script from "./PublicTable.vue?vue&type=script&lang=js&"
export * from "./PublicTable.vue?vue&type=script&lang=js&"
import style0 from "./PublicTable.vue?vue&type=style&index=0&id=3c94892c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c94892c",
  null
  
)

export default component.exports